<template>
<v-app class="app-container">
  <Header />
  <ModalForm />
  <router-view></router-view>
  <Footer />

</v-app>
</template>

<script>
import Header from './components/_header/component';
import Footer from "./components/_footer/component";
import ModalForm from './components/_modal/component';

export default {
  name: 'app',
  components: {
    Header,
    Footer,
    ModalForm
  },
  methods: {
  },
}

</script>

<style lang="scss">
@import "./styles/styles";

</style>
